module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/pages/entities/index/entity-index.page.scss
// module id = ./libs/chassis-core/src/app/pages/entities/index/entity-index.page.scss
// module chunks = main